import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

// Hardcode: In order to manual sorting (req from marketing dept)
const journalPosts = [
  '0fb0bd54-593c-4f4a-a24e-ba912a468bc5',
  '84d5a880-d16c-4025-af3c-a88b5de1b11d',
  '6c316414-9968-4416-94fb-45c53b5d48e7',
  'ae44e448-32b1-43cb-ae11-cebf62976299',
  'cdfc7e9b-d24b-4ef6-ba0b-1db3b81812b7',
];

const renderPost = (index, uuid, allPosts) => {
  const article = allPosts.find(({ node }) => node.uuid === uuid);
  return (
    <div className="article-wrapper">
      <a href={article.node.url}>
        <div className="row mx-0">
          <div className="col-1 pl-0 text-green article-index">
            <span>{index + 1}</span>
          </div>
          <div className="col-6 pl-0 text-justify pr-0">
            <span className="article-tag text-green">
              <small>{article.node.primary_tag.name}</small>
            </span>
            <div className="article-title">
              {article.node.title.substr(0, 25 - 1) + '...'}
            </div>
          </div>
          <div className="col-5 pr-0">
            <Img
              alt={article.node.title}
              fluid={article.node.localImage.childImageSharp.fluid}
            />
          </div>
        </div>
      </a>
    </div>
  );
};

const JournalFeaturedPosts = () => (
  <StaticQuery
    query={graphql`
      query {
        allJournalFeaturedPost {
          edges {
            node {
              id
              uuid
              url
              title
              feature_image
              primary_tag {
                name
              }
              localImage {
                childImageSharp {
                  fluid(maxWidth: 110, maxHeight: 85) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => {
      return (
        <div className="sidebar-wrapper-content">
          <div className="row mx-0 home-popular-articles">
            <div className="col-12 home-popular-articles-title sidebar-wrapper-title">
              <span className="text-green">人気記事ランキング</span>
            </div>
            {journalPosts.map((auid, index) => (
              <React.Fragment key={index}>
                {renderPost(index, auid, data.allJournalFeaturedPost.edges)}
              </React.Fragment>
            ))}
          </div>
        </div>
      );
    }}
  />
);

export default JournalFeaturedPosts;
